// Debounce a fast-changing value (a search box) so a keystroke does not become
// a request. Extracted from the Developers page once the server-searched lists
// multiplied; every page that sends `q` to the backend shares this one delay,
// so "how live is search" is one decision instead of five.
import { useEffect, useState } from "react";

export function useDebounced<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(id);
  }, [value, ms]);
  return debounced;
}
